import React from "react";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

/**
 * Public Waitlist success page. No auth. No tracking.
 */
export default function WaitlistDankePage() {
  return (
    <main
      className="min-h-screen bg-ag-paper text-ag-ink"
      data-testid="waitlist-danke-page"
    >
      <header className="mx-auto flex max-w-6xl items-center px-5 py-6 lg:px-8">
        <Link to="/" className="flex items-center" aria-label="Zur Startseite">
          <Logo variant="full" tone="light" className="h-9 w-auto md:h-10" />
        </Link>
      </header>
      <section className="mx-auto max-w-xl px-5 py-24 text-center lg:py-32">
        <div className="mx-auto mb-8 h-px w-16 bg-amber-500/70" aria-hidden="true" />
        <h1 className="font-serif text-3xl leading-tight text-ag-ink sm:text-4xl lg:text-5xl">
          Vielen Dank.
        </h1>
        <p className="mt-6 text-base leading-relaxed text-slate-700 sm:text-[17px]">
          Ihre E-Mail-Adresse wurde bestätigt. Wir informieren Sie, sobald
          ALLES GEREGELT startet.
        </p>
        <Link
          to="/"
          className="mt-10 inline-flex min-h-12 items-center justify-center rounded-full border border-ag-ink/70 px-6 text-sm font-medium text-ag-ink transition hover:bg-ag-ink/5"
          data-testid="waitlist-danke-home"
        >
          Zur Startseite
        </Link>
      </section>
    </main>
  );
}
